import React from "react";
import AppHeader from "./AppHeader";
import UpcomingBanner from "./UpcomingBanner";
import BuildBadge from "./BuildBadge";

export default function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <AppHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</main>
      <footer className="border-t border-white/5 mt-16 py-8 text-center text-xs text-zinc-500" data-testid="app-footer">
        © {new Date().getFullYear()} Pick2Play. Find your game.
        <BuildBadge />
      </footer>
      <UpcomingBanner />
    </div>
  );
}
